import { initRouter } from './router';
import './styles/main.css';

document.addEventListener('DOMContentLoaded', () => {
    initRouter();
});
